import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container maxWidth-sm"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Choose which user data to delete:")
  ])
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-10 col-sm-offset-1 text-big" }
const _hoisted_8 = ["onChange", "onUpdate:modelValue"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row text-big" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Here are the actions that were taken:")
], -1)
const _hoisted_15 = { class: "row text-big" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import axios from "axios";
import { debug as d } from "debug";
import { computed, onMounted, ref } from "vue";
import { ShortUserDetailsApiModel } from "../../api-models";

export interface UserDeletionDataTypeAndDependencies {
  Type: string;
  DependsOn: string[];
  DependedOnBy: string[];
  ExistingRecordCount: number;
}

export interface UserDeletionOptionsApiModel {
  ShortUserDetails: ShortUserDetailsApiModel;
  Options: UserDeletionDataTypeAndDependencies[];
}

interface DeleteUserPageOption extends UserDeletionDataTypeAndDependencies {
  selected: boolean;
  description: string;
  visible: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'delete-user-page',
  props: {
    id: {}
  },
  setup(__props: any) {

const debug = d("cs.DeleteUserPage");

const optionMetadata = {
  UserRecord: { description: "Main user record", visible: true },
  GroupMembership: { description: "Membership of all groups", visible: false },
  DevelopProgress: { description: "Develop progress", visible: true },
  SlackAccessTokens: { description: "Slack access tokens", visible: true },
  MsTeamsConnections: { description: "MS Teams connections", visible: true },
  CustomViewpointsReports: { description: "Custom viewpoints reports", visible: true },
  SubscriptionsAndLicencesOwned: { description: "Owned subscriptions and licences", visible: true },
  UserNotificationInteractions: { description: "Popup notification history", visible: false },
  SoloReviews: { description: "Solo reviews", visible: true },
  ViewpointsOnOthers: { description: "Viewpoints on others", visible: true },
  ViewpointsOnMe: { description: "Viewpoints by others", visible: true },
  EngageQuestionnaires: { description: "Engage questionnaires", visible: true },
  GroupInvitesCreatedByMe: { description: "Group invites created by the user", visible: true },
  GroupInvitesUsedOnlyByMe: { description: "Single-use group invites used", visible: false },
  GroupInviteUses: { description: "All group invites used", visible: false },
  ViewpointsInvitesCreatedByMe: {
    description: "Viewpoints invites created by the user",
    visible: true,
  },
  ViewpointsInviteUsesByMe: { description: "Viewpoints invite uses", visible: false },
  ViewpointsInviteSendsDirectlyToMe: {
    description: "Viewpoints invite sends directly to the user",
    visible: false,
  },
  ActiveLicence: { description: "Active licence", visible: true },
  GiftedLicences: { description: "Licences gifted to other users", visible: true },
  TeamEffectivenessQuestionnaires: {
    description: "Team effectiveness questionnaires",
    visible: true,
  },
  TeamEffectivenessReviews: { description: "Team effectiveness reviews created", visible: false },
  PersonalPathways: { description: "Personal Pathway progress", visible: true },
};

const props = __props;

const shortUserDetails = ref<ShortUserDetailsApiModel | null>(null);
const options = ref<DeleteUserPageOption[]>([]);
const isValid = ref<boolean>(true);
const logMessages = ref<string[] | null>(null);
const isConfirming = ref<boolean>(false);

const optionsToDisplay = computed(() =>
  options.value.filter((o) => o.visible && o.ExistingRecordCount > 0),
);

function selectAll(): void {
  isConfirming.value = false;
  options.value.forEach((o) => {
    o.selected = true;
  });
  isValid.value = true;
}

function selectNone(): void {
  isConfirming.value = false;
  options.value.forEach((o) => {
    o.selected = false;
  });
  isValid.value = false;
}

function cancel(): void {
  window.location.href = `/admin/user/details/${props.id}`;
}

function confirm(): void {
  isConfirming.value = !isConfirming.value;
}

function done(): void {
  const haveDeletedUserEntirely = options.value.some((o) => o.Type === "UserRecord" && o.selected);
  window.location.href = haveDeletedUserEntirely ? "/admin/" : `/admin/user/details/${props.id}`;
}

function onChange(option: DeleteUserPageOption): void {
  isConfirming.value = false;
  // Ensure dependencies are consistent
  if (!option.selected) {
    // Select options it depends on
    options.value.forEach((o) => {
      if (option.DependsOn.includes(o.Type)) {
        o.selected = false;
      }
    });
  } else {
    // Deselect options it's depended upon by
    options.value.forEach((o) => {
      if (option.DependedOnBy.includes(o.Type)) {
        o.selected = true;
      }
    });
  }
  isValid.value = options.value.some((o) => o.selected);
}

function deleteUser(): void {
  const optionValues = options.value.reduce((obj, o) => {
    obj[o.Type] = o.selected ? "Delete" : "Leave";
    return obj;
  }, {});

  const data = {
    Values: optionValues,
  };

  axios.post(`/api/userdeletion/${props.id}`, data).then((resp) => {
    logMessages.value = resp.data as string[];
  });
}

onMounted(() => {
  axios.get(`/api/userdeletion/${props.id}`).then((resp) => {
    const model = resp.data as UserDeletionOptionsApiModel;
    debug(model);
    shortUserDetails.value = model.ShortUserDetails;
    options.value = model.Options.map((o: UserDeletionDataTypeAndDependencies) => ({
      // Augment the server model with additional properties
      ...o,
      selected: true,
      description: optionMetadata[o.Type].description,
      visible: true,
    }));
  });
});

return (_ctx: any,_cache: any) => {
  return (options.value.length > 0 && !!shortUserDetails.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!logMessages.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h1", null, "Delete user \"" + _toDisplayString(shortUserDetails.value.firstName) + " " + _toDisplayString(shortUserDetails.value.lastName) + "\"", 1)
              ]),
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", { class: "form-group text-big" }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: selectNone
                    }, "None"),
                    _createTextVNode(" | "),
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: selectAll
                    }, "All")
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsToDisplay.value, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: option.Type,
                      class: "checkbox text-big"
                    }, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          onChange: ($event: any) => (onChange(option)),
                          "onUpdate:modelValue": ($event: any) => ((option.selected) = $event)
                        }, null, 40, _hoisted_8), [
                          [_vModelCheckbox, option.selected]
                        ]),
                        _createTextVNode(" " + _toDisplayString(option.description) + " (" + _toDisplayString(option.ExistingRecordCount) + ") ", 1)
                      ])
                    ]))
                  }), 128)),
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      class: "btn btn-lg btn-default",
                      onClick: cancel
                    }, "Cancel"),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-lg btn-primary", { invisible: isConfirming.value }]),
                      onClick: confirm,
                      disabled: !isValid.value || isConfirming.value,
                      style: {"margin-left":"10px"}
                    }, " Delete ", 10, _hoisted_11),
                    (isConfirming.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-lg btn-danger",
                          onClick: deleteUser,
                          style: {"margin-left":"10px"}
                        }, " Sure? "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (logMessages.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h3", null, " Delete completed for \"" + _toDisplayString(shortUserDetails.value.firstName) + " " + _toDisplayString(shortUserDetails.value.lastName) + "\" ", 1)
              ]),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logMessages.value, (message) => {
                    return (_openBlock(), _createElementBlock("li", { key: message }, _toDisplayString(message), 1))
                  }), 128))
                ])
              ]),
              _hoisted_16,
              _createElementVNode("div", { class: "row text-center" }, [
                _createElementVNode("div", { class: "col-sm-10 col-sm-offset-1" }, [
                  _createElementVNode("button", {
                    class: "btn btn-lg btn-primary",
                    onClick: done
                  }, "Done")
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_17
      ]))
    : _createCommentVNode("", true)
}
}

})